export interface BrowserInfo {
  mobile: boolean;
  tablet: boolean;
  android: boolean;
  usesSwipeTransitions: boolean;
  needsCssVideoBackground: boolean;
}

let browserInfo: BrowserInfo | null = null;

/**
 * Subset of `@voxmedia/duet-ui/utils/get-browser-info` used by CskCoralDrawer.
 * That path is not in duet-ui's ESM build, so CSK cannot import it.
 * Returns `null` during SSR.
 */
export default function getBrowserInfo(): BrowserInfo | null {
  if (typeof window === "undefined") {
    return null;
  }
  if (browserInfo) {
    return browserInfo;
  }

  const ua = window.navigator.userAgent;
  const ios = /iPhone|iPod/.test(ua) || /iPad/.test(ua);
  const iPadOS = /Macintosh/.test(ua) && window.navigator.maxTouchPoints > 1;
  const android = /Android/.test(ua);
  const safari =
    /Safari/.test(ua) &&
    !/Chrome|Chromium|CriOS|FxiOS|Edg|EdgiOS|Android/.test(ua);
  const webkit = /AppleWebKit/.test(ua);
  const mobile = /Mobi|Android.*Mobile|iPhone|iPod/.test(ua);
  const tablet = /iPad|Tablet|Android(?!.*Mobile)/.test(ua) || iPadOS;

  browserInfo = {
    mobile,
    tablet,
    android,
    usesSwipeTransitions: safari || (webkit && (ios || iPadOS)),
    /** WebKit paints `background-image: url(video.mp4)`; Blink still fetches it. */
    needsCssVideoBackground: safari || ios || iPadOS,
  };

  return browserInfo;
}
